import React, { useMemo, useState } from "react";
import { User, Users } from "lucide-react";

import { useAppSelector } from "../../../app/hooks";

import { getEmployeeIds } from "../../caseinfo/logic/Slice";

import { InvestigationEntityCard } from "./InvestigationEntityCard";

import AddEmployeeModal from "./AddEmployeeModal";
import ManageEmployeeModal from "./ManageEmployeeModal";
import { EntityModalType } from "./LoanAccountCard";

const LegacyEmployeeCard: React.FC = () => {
  const employeeIds = useAppSelector( getEmployeeIds);

  const [activeModal, setActiveModal] = useState<EntityModalType | null>(null);
  const [previousModal, setPreviousModal] = useState<EntityModalType | null>(null);

  const employeeItems = useMemo(
    () => employeeIds,
    [employeeIds]
  );

  const closeModal = () => {
    setActiveModal(null);
    setPreviousModal(null);
  };

  return (
    <>
      <InvestigationEntityCard
        title="Employees"
        items={employeeItems}
        onAdd={() =>{
          setPreviousModal(null)
          setActiveModal(EntityModalType.ADD)
        } 
        }
        onManage={() =>{
          setPreviousModal(null)
          setActiveModal(EntityModalType.MANAGE)
        } 
        }
        popoverProps={{
          title: "Employees",
          allowCopy: true,
          items: employeeIds,
          icon: (
            <User
              size={16}
              className="text-[#94A3B8]"
            />
          ),
        }}
        emptyState={{
          icon: (
            <Users
              size={18}
              className="text-[#0A0A0A]"
            />
          ),
          message: "No employees added",
        }}
      />

      {activeModal === EntityModalType.MANAGE && (
        <ManageEmployeeModal
          onClose={closeModal}
          onAdd={() =>{
            setPreviousModal(EntityModalType.MANAGE)
            setActiveModal(EntityModalType.ADD)
           }  
          }
        />
      )}

      {activeModal === EntityModalType.ADD && (
        <AddEmployeeModal
          onClose={closeModal}
          onBack={() => {
            if (previousModal) {
              setActiveModal(previousModal);
              setPreviousModal(null);
            } else {
              closeModal();
            }
          }}
        />
      )}
    </>
  );
};

export default LegacyEmployeeCard;